
import { useTranslation } from 'react-i18next';

export function Hero() {
  const { t } = useTranslation('common');

  return (
    <section 
      id="hero"
      className="relative min-h-screen flex items-center bg-cover bg-center pt-20"
      style={{
        backgroundImage: `linear-gradient(to right, rgba(255, 255, 255, 0.97) 0%, rgba(255, 255, 255, 0.97) 55%, rgba(255, 255, 255, 0.75) 75%, rgba(255, 255, 255, 0.4) 100%), url('https://public.readdy.ai/ai/img_res/825731f22509d8905b6944e69c9700f5.jpg')`
      }}
    >
      <div className="container mx-auto px-6 lg:px-12 py-20">
        <div className="max-w-3xl">
          <h1 className="text-5xl lg:text-6xl font-bold text-gray-900 mb-6 leading-tight">
            {t('hero.title')} <span className="text-orange-500">{t('hero.titleHighlight')}</span>
          </h1>
          
          <p className="text-xl text-gray-700 mb-8 leading-relaxed">
            {t('hero.description')}
          </p>
          
          <div className="flex flex-wrap gap-4">
            <a 
              href="#contato" 
              className="px-8 py-4 bg-orange-500 text-white font-semibold rounded-lg hover:bg-orange-600 transition-colors whitespace-nowrap cursor-pointer shadow-lg"
            >
              {t('hero.ctaPrimary')}
            </a>
            <a 
              href="#servicos" 
              className="px-8 py-4 bg-white text-orange-500 font-semibold rounded-lg border-2 border-orange-500 hover:bg-orange-50 transition-colors whitespace-nowrap cursor-pointer shadow-lg"
            >
              {t('hero.ctaSecondary')}
            </a>
          </div>
          
          <div className="mt-12 flex flex-wrap gap-8">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center">
                <i className="ri-award-line text-2xl text-white"></i>
              </div>
              <div>
                <div className="text-2xl font-bold text-gray-900">19+</div>
                <div className="text-sm text-gray-600">{t('hero.yearsExperience')}</div>
              </div>
            </div>
            
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 bg-blue-900 rounded-full flex items-center justify-center">
                <i className="ri-shield-check-line text-2xl text-white"></i>
              </div>
              <div>
                <div className="text-2xl font-bold text-gray-900">100%</div>
                <div className="text-sm text-gray-600">{t('hero.compliance')}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
